import { useEffect, useState } from "react";
import axios from "axios";
import { URL_BASE, ver } from "../constants/url";
import { useDispatch, useSelector } from "react-redux";
import { setModalVersionShow, setValidVersion } from "../context/actions/appActions";
import { Button, Modal } from "antd";
import { startGetClientes } from "../context/actions/clientesActions";
import { startGetProveedores } from "../context/actions/proveedoresActions";

export const ValidateVersion = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false)
  const [backendVersion, setBackendVersion] = useState(null)

  const showModal = useSelector(state => state.appReducer.showModal)

  useEffect(() => {

    dispatch(startGetClientes())
    dispatch(startGetProveedores())
    axios.get(`${URL_BASE}/api/ver/GetFrontAdminVer`).then(res => {
      setBackendVersion(res.data)
      if (res.data !== ver) {
        dispatch(setValidVersion(false))
        setOpen(showModal === 'show')
      }
    })
  }, [dispatch]);


  const onOk = () => {
    window.location.reload()
  }

  const onCancel = () => {
    dispatch(setModalVersionShow(false))
    setOpen(false)
  }



  //
  return (
    <>
      <Modal onCancel={() => setOpen(false)} title={'Actualizar versión'} open={open} footer={null}>
        <p>Existe una nueva versión de SIGSA-ADMIN</p>
        <p>El endpoint <b>GetFrontAdminVer</b> devuelve: <b>{backendVersion}</b></p>

        <p>¿ Desea actualizar ?  </p>
        <div>
          <Button onClick={onCancel} type="primary" danger>No</Button>
          <Button onClick={onOk} type="primary" style={{marginRight: '20px'}}>Si</Button>
        </div>
      </Modal>
    </>
  )
}